import Swiper from "swiper";
import {Pagination} from "swiper/modules";
import 'swiper/css/bundle';
import BotCheckerForm from "./bot-checker-form";
import IMask from "imask";
Swiper.use([Pagination]);

export default class Franchise
{
    constructor() {
        this.botCheckerForm = new BotCheckerForm();
        this.initListeners();
        this.initSwiper();
        this.initForm();
    }

    initListeners() {
        document.querySelectorAll('[js-franchise-connect-btn]').forEach((btns) => {
            btns.addEventListener('click', () => {
                const form = document.querySelector('#franchise_form');
                form.scrollIntoView({
                    behavior: 'smooth'
                });
            });
        })

        // Переключение радиокнопок в форме
        document.querySelectorAll('[js-franchise-radio]').forEach((radio) => {
            radio.addEventListener('click', (e) => {
                const radioId = e.target?.dataset?.radioId;
                document.getElementById(radioId).checked = true;
                document.querySelectorAll('.contact-form__radio-marker').forEach((el) => {
                    el.classList.remove('contact-form__radio-marker_active');
                })
                document.querySelector(`[data-radio-id="${radioId}"]`).classList.add('contact-form__radio-marker_active');
            });
        })
    }

    initSwiper() {
        if (document.querySelector('.js-franchise-swiper')) {
            this.swiper = new Swiper('.js-franchise-swiper', {
                slidesPerView: "auto",
                spaceBetween: 30,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
            });
        }
    }

    initForm() {
        const maskEmail = {
            mask: function (value) {
                if (/^[a-z0-9_\.-]+$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}\.$/.test(value))
                    return true;
                if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}\.[a-z]{1,4}$/.test(value))
                    return true;
                return false;
            },
            lazy: false
        }
        const emailInput = document.querySelector('.js-input-email');
        if (emailInput) {
            this.maskReadyEmail = new IMask(emailInput, maskEmail);
        }

        const btn = document.querySelector('.js-send-form-franchise');
        if (btn) {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                this.sendForm();
            });
        }
    }

    sendForm() {
        const resultText = document.querySelector('.js-form-franchise-result');

        this.botCheckerForm.setCookie(
            "cl-time-on-page",
            this.botCheckerForm.getTimeFromStart(),
            1
        );

        const workingOperator = document.querySelector('#working_operator_yes').checked ? 'Да' : 'Нет';

        const jsonBody = {
            email: document.querySelector('.js-input-email').value,
            message: document.querySelector('.js-input-message-franchise').value,
            working_operator: workingOperator,
            fax: document.querySelector('.js-input-fax-franchise').value,
            reCaptchaToken: this.botCheckerForm.getGRecaptchaToken()
        }

        const csrfToken = document.querySelector("meta[name='csrf-token']").content;
        fetch(
            '/franchise/send',
            {
                method: 'post',
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": csrfToken
                },
                credentials: "same-origin",
                body: JSON.stringify(jsonBody),
            }
        ).then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error('Something went wrong');
            }
        }).then(responseJson => {
            if (responseJson.status === "ok") {
                resultText.innerHTML = responseJson.text;
            } else {
                resultText.innerHTML = responseJson.message;
            }
        }).catch((error) => {
            resultText.innerHTML = "Ошибка отправки! Повторите попытку позже или позвоните нам!"
        });
    }
}
